// MENSAJES AUTOMÁTICOS — una sola pantalla (F2 reorden 24-oct-2026).
// Antes el menú «Comunicación» traía 8 entradas que eran el MISMO editor (EventMessageEditor) con distinto evento,
// más Reseñas en Google. Ahora: una lista con nombre · cuándo se manda · canal · encendido, y «Editar» abre el editor
// de siempre con ?evento=<clave>. Las rutas viejas (/dashboard/welcome-message…) redirigen aquí. Nada cambia en el
// backend: la lista lee /messages/settings (una llamada para los 7 eventos) y /google-reviews/settings.
// F3 (24-oct-2026): la lista vive en components/FilasMensajes y el catálogo en ../mensajesCatalogo, para que Referidos
// y Membresías enseñen sus propias filas. Plan: forobeta-ops/docs/lealify-manager-reorden-menu-y-mi-negocio-plan-20261024.md §3.4
import React, { useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { MessageSquare, Crown } from 'lucide-react';
import Layout from '../../../components/layout/Layout';
import { useAuth } from '../../../context/AuthContext';
import { isPro as checkIsPro } from '../../../utils/planPermissions';
import FilasMensajes from '../components/FilasMensajes';
import { type EventoClave } from '../mensajesCatalogo';
import WelcomeMessagePage from './WelcomeMessagePage';
import VisitMessagePage from './VisitMessagePage';
import ReferralMessagePage from './ReferralMessagePage';
import FeedbackAlertPage from './FeedbackAlertPage';
import LowBalanceAlertPage from './LowBalanceAlertPage';
import GoogleReviewsPage from './GoogleReviewsPage';
import MembershipExpiringPage from './MembershipExpiringPage';
import MembershipExpiredPage from './MembershipExpiredPage';

export { FILAS, RUTA_VIEJA_A_EVENTO, type EventoClave } from '../mensajesCatalogo';

const EDITORES: Record<EventoClave, React.FC> = {
  welcome: WelcomeMessagePage, visit: VisitMessagePage, referral: ReferralMessagePage, feedback_alert: FeedbackAlertPage,
  low_balance: LowBalanceAlertPage, google_reviews: GoogleReviewsPage, membership_expiring: MembershipExpiringPage, membership_expired: MembershipExpiredPage,
};

const AutomaticMessagesPage: React.FC = () => {
  const [params] = useSearchParams();
  const evento = params.get('evento') as EventoClave | null;
  const { currentUser } = useAuth();
  const esPro = checkIsPro(currentUser?.subscription);
  const [resumen, setResumen] = useState<{ on: number; total: number } | null>(null);

  // Un editor concreto: la pantalla de siempre (trae su propio Layout y su enlace de regreso).
  const Editor = evento && EDITORES[evento] ? EDITORES[evento] : null;
  if (Editor) return <Editor />;

  return (
    <Layout>
      <div className="w-full space-y-6" data-testid="mensajes-pagina">
        <div className="animate-fade-in-up">
          <h1 className="text-xl sm:text-2xl font-bold text-content flex items-center">
            <MessageSquare className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-accent" />Mensajes automáticos
            {!esPro && <span title="Función exclusiva para usuarios PRO" className="inline-flex ml-2"><Crown className="h-5 w-5 text-yellow-500" /></span>}
          </h1>
          <p className="mt-1 text-sm text-content-2">
            Los mensajes que Lealify manda solo, por WhatsApp o por correo, cuando pasa algo con un cliente. Aquí ves cuáles están encendidos y editas el texto de cada uno.
            {esPro && resumen && <span className="text-content-3"> · {resumen.on} de {resumen.total} encendidos</span>}
          </p>
        </div>

        <FilasMensajes onCargado={(on, total) => setResumen({ on, total })} />

        <p className="text-xs text-content-3">
          Las campañas (envíos masivos que tú decides) viven aparte, en <RouterLink to="/dashboard/campaigns" className="text-accent hover:underline">Campañas</RouterLink>.
          La línea de WhatsApp del negocio se conecta en <RouterLink to="/dashboard/whatsapp" className="text-accent hover:underline">WhatsApp del negocio</RouterLink>.
        </p>
      </div>
    </Layout>
  );
};

export default AutomaticMessagesPage;
